import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FilterSearchBox from '../SearchBox/FIlterSearchBox';
import ChecksGroup, { CheckOptionType } from './ChecksGroup';

export default class FilteredChecksGroup extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(CheckOptionType).isRequired,
        filterFn: PropTypes.func.isRequired,
        placeholderMessageId: PropTypes.string,
        before: PropTypes.element,
        after: PropTypes.element
    }

    static defaultProps = {
        before: null,
        after: null
    }

    constructor(props) {
        super(props);

        this.state = {
            inputFieldValue:    '',
            options: this.props.options
        }

        this.inputListHandler = this.inputListHandler.bind(this);

        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ options: nextProps.options })
    }

    onChange(allOptions, selected, e) {
        const options = this.state.options.map(option => ({ ...option, value: option.key === selected.key ? selected.value : option.value }))
        this.setState({ options }, () => {
            this.props.onChange(this.state.options, selected, e)
        })
    }

    inputListHandler(inputFieldValue) {
        this.setState({ inputFieldValue: inputFieldValue });
    }

    render() {
        const options = this.state.options.filter(option => this.props.filterFn(option, this.state.inputFieldValue))

        return (
            <div>
                <FilterSearchBox inputListHandler={this.inputListHandler}
                                 inputFieldValue={this.state.inputFieldValue}
                                 placeholderMessageId={this.props.placeholderMessageId} />
                <div>
                    {this.props.before}
                    <ChecksGroup { ...this.props} onChange={this.onChange} options={options} />
                    {this.props.after}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/FilteredChecksGroup.jsx